import type { DiscoveredRouteModule } from '@/router/generator/types';

const AdminMailView = () => import('@/views/admin/MailView.vue');
export const NAME_ADMIN_MAIL = 'AdminMail';
export const PATH_ADMIN_MAIL = 'mail';

export const route: DiscoveredRouteModule = {
  id: 'admin.mail',
  scope: 'admin',
  moduleKey: 'mail',
  name: NAME_ADMIN_MAIL,
  path: PATH_ADMIN_MAIL,
  component: AdminMailView,
  meta: { requiresAdmin: true, dataLoaders: ['project_document', 'features', 'project_mail'] },
};
